import { PanelConfig } from './PANEL-CONFIG';
import { usePanelStore } from './store';

export const toggleGlobalPanel = (panelId: PanelConfig) => {
  usePanelStore.getState().setOpenGlobalPanel(panelId, (prevState) => !prevState);
};
export const closeGlobalPanel = (panelId: PanelConfig) => {
  usePanelStore.getState().setOpenGlobalPanel(panelId, false);
};
export const openGlobalPanel = (panelId: PanelConfig) => {
  usePanelStore.getState().setOpenGlobalPanel(panelId, true);
};

export const enableForceTray = () => {
  usePanelStore.getState().setForceTray(true);
};

export const disableForceTray = () => {
  usePanelStore.getState().setForceTray(false);
};

export const toggleForceTray = () => {
  const currentState = usePanelStore.getState().forceTray;
  usePanelStore.getState().setForceTray(!currentState);
};

export const isForceTrayEnabled = () => {
  return usePanelStore.getState().forceTray;
};

export const GlobalPanel = {
  toggle: toggleGlobalPanel,
  close: closeGlobalPanel,
  open: openGlobalPanel,
};

export const PanelEngine = {
  enableForceTray,
  disableForceTray,
  toggleForceTray,
  isForceTrayEnabled,
};
